import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";
import "./landing.css";
import { ToastContainer, toast } from "react-toastify";
import Randomstring from "randomstring";
import { useNavigate } from "react-router-dom";
import classes from "./Upload.module.css";
import swal from "sweetalert";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
export default function FundAccount() {
  const navigate = useNavigate();
  const base_url = process.env.REACT_APP_BASE_URL;
  const [emailError, setEmailError] = useState();
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [fullName, setFullName] = useState("");
  const [amount, setAmount] = useState(5000);
  const [units, setUnits] = useState(50);
  const [reoccuring, setReoccuring] = useState(false);
  const [isExisting, setIsExisiting] = useState(false);
  const [response, setResponse] = useState(false);
  const [formattedAmount, setFormattedAmount] = useState("₦");
  const [show, setShow] = useState(false);
  const [respData, setResData] = useState([]);
  const [file, setFile] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    const formatted = amount.toLocaleString("en-NG", {
      style: "currency",
      currency: "NGN",
      minimumFractionDigits: 0,
    });
    // Round the amount to the nearest 1000

    // Update the units based on the rounded amount

    if (amount >= 5000 && amount % 100 === 0) {
      setUnits(amount / 100);
    } else if (amount >= 5000 && amount % 1000 !== 0) {
      const roundedAmount = Math.round(amount / 1000) * 1000;
      setAmount(roundedAmount);
      setUnits(amount / 100);
    } else {
      setUnits(0);
    }
    setFormattedAmount(formatted);
  }, [amount]);


  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      // Check if the selected file is a PDF, JPG, or PNG
      if (file.type === 'application/pdf' || file.type === 'image/jpeg' || file.type === 'image/png') {
        // Check if the file size is within the limit (100KB)
        if (file.size <= 100 * 1024) {
          setSelectedFile(file);
          setError('');
        } else {
          setError('File size exceeds the limit (100KB)');
          setSelectedFile(null);
        }
      } else {
        setError('Invalid file type. Supported types: PDF, JPG, PNG');
        setSelectedFile(null);
      }
    }
  };
  const uploadFile = () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('email', email);
      formData.append('phone_number', phoneNo);
      formData.append('full_name', fullName);
      axios.post(`${base_url}/turbo/upload-payment`, formData)
        .then((response) => {
          console.log(response.data);
          swal({
            title: "Submitted",
            text: "submitted successfully",
            icon: "success",
            button: "Ok",
          })
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  const searchUser = () => {
    axios
      .post(`${base_url}/turbo/search-user`, { email })
      .then((response) => {
        if (response.data.length > 0) {
          setShow(true);
          setResData(response.data);
        } else {
          setResponse(true);
        }
      })
      .catch((err) => console.log(err));
  };

  const config = {
    public_key: "FLWPUBK-4c2c5a084d69c4b272cc98bfa23511a8-X",
    tx_ref: "CI-" + Randomstring.generate(7),
    amount: amount,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    // redirect_url: "corperinvest.norrenberger.com",
    customer: {
      email: email,
      phone_number: phoneNo,
      name: fullName,
    },
    customizations: {
      title: "Fund Account",
      description: "Subscribe to Turbo Fund",
      logo: "https://norrenberger.com/wp-content/uploads/2022/11/image-1-1.png",
    },
  };

  const config2 = {
    public_key: "FLWPUBK-4c2c5a084d69c4b272cc98bfa23511a8-X",
    tx_ref: "CI-" + Randomstring.generate(7),
    amount: amount,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    payment_plan: "98882",
    // redirect_url: "corperinvest.norrenberger.com",
    customer: {
      email: email,
      phone_number: phoneNo,
      name: fullName,
    },
    customizations: {
      title: "Fund Account",
      description: "Fund Corper Invest Account",
      logo: "https://norrenberger.com/wp-content/uploads/2022/11/image-1-1.png",
    },
  };

  const handleFlutterPayment = useFlutterwave(config);
  const handleFlutterPayment2 = useFlutterwave(config2);
  const handleChange = () => {
    setReoccuring(!reoccuring);
    console.log(reoccuring);
  };
  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    const numericValue = parseFloat(inputValue.replace(/[^\d]/g, ""));

    if (!isNaN(numericValue)) {
      setAmount(numericValue);
      if (numericValue > 5000) {
        setUnits(numericValue / 100);
      }
    }
  };



  const handleKeyDown = (e) => {
    // Check for backspace key (keyCode 8) and update the amount accordingly
    if (e.keyCode === 8 && amount > 0) {
      e.preventDefault();
      const newAmount = Math.floor(amount / 10);
      setAmount(newAmount);
    }
  };

  return (
    <div>
      <ToastContainer />
      <Navbar/>
      &nbsp;
      &nbsp;
      &nbsp;
      <br/>
      <div className="form_collector mt-5"><br/>
        <div className="form_wrapper pt-5 " style={{ height: "650px"}}>
          <h6>
            <b>Subscribe to Norrenberger Turbo Fund</b>
          </h6>
          <div className="form_container" style={{ fontSize: "smaller" }}>
            <>
              Kindly fill your registered email addresss to search if you are an
              exisitng user to proceed{" "}
            </>
            <form
              style={{ width: "70%", textAlign: "center" }}
              className="mx-auto my-4"
            >
              <div className="flex" style={{ textAlign: "left" }}>
                <label
                  htmlFor="email"
                  style={{ fontSize: "smaller", marginLeft: 10 }}
                >
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  className="m-2"
                  value={email || ""}
                  onChange={(e) => {
                    e.preventDefault();
                    setResponse(false);
                    const { name, value } = e.target;
                    if (name === "email") {
                      if (!value) {
                        setEmailError("Email is required");
                      } else if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
                      ) {
                        setEmailError("Invalid email address");
                      } else {
                        setEmailError(null);
                      }
                    }
                    setEmail(value);
                  }}
                />
                {emailError ? (
                  <div
                    style={{ color: "red", fontSize: "smaller" }}
                    className="px-3"
                  >
                    {emailError}
                  </div>
                ) : null}
                {response ? (
                  <div
                    style={{ color: "red", fontSize: "smaller" }}
                    className="px-3"
                  >
                    No user found with email address
                  </div>
                ) : null}
              </div>
              {isExisting ? (
                <>
                  {" "}
                  <div className="flex" style={{ textAlign: "left" }}>
                    <label
                      htmlFor="fullName"
                      style={{ fontSize: "smaller", marginLeft: 10 }}
                    >
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      disabled={true}
                      id="fullName"
                      className="m-2 form-input"
                      placeholder="Full Name"
                      value={fullName || ""}
                      onChange={(e) => {
                        e.preventDefault();
                        setFullName(e.target.value);
                      }}
                    />
                  </div>
                  <div className="flex" style={{ textAlign: "left" }}>
                    <label
                      htmlFor="fullName"
                      style={{ fontSize: "smaller", marginLeft: 10 }}
                    >
                      Phone Number
                    </label>
                    <input
                      type="number"
                      name="phoneNo"
                      disabled={true}
                      placeholder="Phone Number"
                      className="m-2"
                      value={phoneNo || ""}
                      onChange={(e) => {
                        e.preventDefault();
                        setPhoneNo(e.target.value);
                      }}
                    />
                  </div>
                  <div className="flex" style={{ textAlign: "left" }}>
                    <label
                      htmlFor="fullName"
                      style={{ fontSize: "smaller", marginLeft: 10 }}
                    >
                      Units
                    </label>
                    <input
                      type="number"
                      name="units"
                      placeholder="Number Units"
                      className="m-2"
                      min={50}
                      step={10}
                      value={units}
                      disabled={true}
                      onChange={(e) => {
                        e.preventDefault();
                        if (e.target.value >= 50) {
                          setUnits(e.target.value);
                          let calcAmount = e.target.value * 100;
                          setAmount(calcAmount);
                        }
                      }}
                    />
                  </div>
                  <div className="flex" style={{ textAlign: "left" }}>
                    <label
                      htmlFor="fullName"
                      style={{ fontSize: "smaller", marginLeft: 10 }}
                    >
                      Amount
                    </label>
                    <input
                      type="text"
                      className="m-2"
                      value={formattedAmount}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Amount"
                    />
                  </div>
                  <div>
                    {/* <div className="d-flex" id="cb1">
                      <div className="p-1">
                        {" "}
                        <label htmlFor="cb1">
                          Would you like this to be a recurring monthly payment?
                        </label>
                      </div>

                      <div className="p-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault2"
                          checked={!reoccuring}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          No
                        </label>
                      </div>

                      <div className=" p-1">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault1"
                          checked={reoccuring}
                          onChange={handleChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Yes
                        </label>
                      </div>
                    </div> */}
                  </div>
                  <div style={{ fontSize: "smaller", color: "#f15a29" }}>
                    *minimum purchase price is ₦5000
                  </div>
                </>
              ) : (
                <div></div>
              )}
            </form>
            {isExisting ? (
              <div>
                <b>Please transfer amount to the account listed below and upload proof of payment:
             </b>   <h6 style={{ fontSize: "small" }}> 
                  Account name: UBA NOM NORRENBERGER TURBO FIXED INCOME FUND DLM
                  TRUST
                </h6>
                <h6 style={{ fontSize: "smaller" }}>Account no: 3004245534</h6>
                <div className="row">
           

            <div className={`${classes.input_field} col-md-6`}>
              <label for="file">Proof of Payment</label> <br />
             
              <input
                type="file"
                accept=".pdf, .jpg, .png"
                name="file"
                id="file"
                className={classes.file_select}
                onChange={handleFileChange}
                required
              />
              <p className={classes.file__message}>
                file should be in jpeg or jpg format (Max File Size 100kb)
              </p>
            </div>
            <div className="col-md-6">
              <button  className="landing_btn  m-2" onClick={()=>{
               uploadFile()
                 
              }}>Submit</button>
            </div>
          </div>
              </div>
            ) : (
              // <button
              //   className="landing_btn  m-2"
              //   onClick={() => {
              //     if (
              //       amount === "" ||
              //       fullName === "" ||
              //       phoneNo === "" ||
              //       email === ""
              //     ) {
              //       toast.error(" Kindly fill all fields to proceed!", {
              //         position: "top-right",
              //         autoClose: 5000,
              //         hideProgressBar: false,
              //         closeOnClick: true,
              //         pauseOnHover: true,
              //         draggable: true,
              //         progress: undefined,
              //         theme: "light",
              //       });
              //     } else {
              //       if (reoccuring) {
              //         handleFlutterPayment2({
              //           callback: (response) => {
              //             setFullName("");
              //             setPhoneNo("");
              //             setEmail("");
              //             setAmount("");
              //             setReoccuring(false);
              //             closePaymentModal(); // this will close the modal programmatically

              //             toast.success(
              //               ` Payment Status:${response.status}.Your payment of ₦${response.amount}! Please check your email for Transaction detail`,
              //               {
              //                 position: "top-right",
              //                 autoClose: 5000,
              //                 hideProgressBar: false,
              //                 closeOnClick: true,
              //                 pauseOnHover: true,
              //                 draggable: true,
              //                 progress: undefined,
              //                 theme: "light",
              //               }
              //             );
              //           },
              //           onClose: () => {
              //             setTimeout(function () {
              //               navigate("/");
              //             }, 6000);
              //           },
              //         });
              //         //end
              //       } else {
              //         handleFlutterPayment({
              //           callback: (response) => {
              //             console.log(response);
              //             setFullName("");
              //             setPhoneNo("");
              //             setEmail("");
              //             setAmount("");
              //             setReoccuring(false);
              //             closePaymentModal(); // this will close the modal programmatically

              //             toast.success(
              //               ` Payment Status:${response.status}.Your payment of ₦${response.amount}! Please check your email for Transaction detail`,
              //               {
              //                 position: "top-right",
              //                 autoClose: 5000,
              //                 hideProgressBar: false,
              //                 closeOnClick: true,
              //                 pauseOnHover: true,
              //                 draggable: true,
              //                 progress: undefined,
              //                 theme: "light",
              //               }
              //             );
              //           },
              //           onClose: () => {
              //             setTimeout(function () {
              //               navigate("/");
              //             }, 6000);
              //           },
              //         });
              //       }
              //     }
              //   }}
              // >
              //   Proceed to Payments
              // </button>
              <button className="landing_btn  m-2" onClick={searchUser}>
                Search
              </button>
            )}
            <div
              className="modal show"
              style={{ display: "block", position: "initial" }}
            >
              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                  <b>Accounts Found</b>
                </Modal.Header>
                <Modal.Body>
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Phone Number</th>
                        <th>Customer ID</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {respData.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item.CUSTOMER_NAME}</td>
                            <td>{item.PHONE_NUMBERS}</td>
                            <td>{item.CUSTOMER_ID}</td>
                            <td>
                              <button
                                className="landing_btn  m-1"
                                style={{ padding: "5px" }}
                                onClick={() => {
                                  setIsExisiting(true);
                                  setFullName(item.CUSTOMER_NAME);
                                  setPhoneNo(item.PHONE_NUMBERS);
                                  handleClose();
                                }}
                              >
                                Select
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}
